import * as React from "react";

interface AccessibleContentProps {
	children?: React.ReactNode;
	/**
	 * The accessible label for the icon. This label will be visually hidden but announced to screen
	 * reader users, similar to `alt` text for `img` tags.
	 */
	label: string;
	As?: "span" | "p";
}

// Inspired by @radix-ui/react-accessible-icon
export const AccessibleContent = ({
	children,
	label,
	As = "span",
}: React.PropsWithChildren<AccessibleContentProps>) => {
	return (
		<>
			{React.Children.map(children, (child) =>
				!React.isValidElement(child)
					? child
					: React.cloneElement(child as React.ReactElement<React.HTMLAttributes<HTMLElement>>, {
							"aria-hidden": true,
						}),
			)}
			<As className="sr-only">{label}</As>
		</>
	);
};
